module.exports = __webpack_public_path__ + "media/images/sr_accountType-25289dc1.svg";